var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PicTagLegalCopyRecommend"},[(_vm.picItemInfo.type == 2)?_c('i',{staticClass:"icon_PicTagLegalCopyRecommend"}):_vm._e(),_vm._v(" "),(_vm.picItemInfo.type == 3)?_c('i',{staticClass:"icon_PicTagLegalCopySpecial"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }